module.exports = __webpack_public_path__ + "static/media/Cowboy.83ae31bc.jpg";